// Where a correction goes.
//
// This component is the positive half of "nothing in the decisions list is editable". The
// design does not merely forbid an edit control; it asks that "the interface should make
// that discoverable rather than leaving the user hunting for a control that does not
// exist". A list with no controls and no explanation reads as an oversight, and the person
// most likely to want a correction is the one least likely to guess that talking is how
// you make one.
//
// So the sentence is always present — not a tooltip, not behind a help icon, not shown
// only when the list is empty. Plain text, no control: the conversation this refers to is
// already visible wherever this renders, beside the panel on desktop and under the sheet's
// own composer on mobile, so there is nothing for a link or button to usefully do here.

export type DecisionsNoteProps = Record<string, never>;

export function DecisionsNote(): JSX.Element {
  return (
    <p className="note">
      Mor keeps this list from your conversations. Say so there if anything is wrong or
      missing.
    </p>
  );
}
